export default __webpack_public_path__ + "static/media/1412.f803fd47.png";